import { useSyncExternalStore } from 'react';
import type { ConnectivityState } from '@life-os/app-core';

// Live online/offline state, driven by the browser's network events.
// Defaults to 'online' during SSR/initial render where navigator is absent.
export function useConnectivity(): ConnectivityState {
  return useSyncExternalStore(
    (onChange) => {
      window.addEventListener('online', onChange);
      window.addEventListener('offline', onChange);
      return () => {
        window.removeEventListener('online', onChange);
        window.removeEventListener('offline', onChange);
      };
    },
    () => (typeof navigator !== 'undefined' && navigator.onLine ? 'online' : 'offline'),
    () => 'online',
  );
}
